<style>
  .bg-footer {
    background: #f7f7f7 !important;
  }
</style>
<template functional>
    <footer class="the-footer bg-footer py-8" :class="classes">
        <section class="vx-row justify-center w-full">
          <div class="vx-col w-full md:w-2/3 lg:w-2/3 xl:w-4/5">
            <main class="vx-row items-center justify-between">
              <!-- Logo White -->
              <div class="vx-col w-full md:w-1/2">
                <img src="/assets/images/layanan-ambulance/logo-footer.svg" class="w-full xl:w-1/2" alt="" />
              </div>
              <div class="vx-col hidden md:block md:w-1/2">
                <div class="flex w-full justify-end">
                  <img src="/assets/images/layanan-ambulance/ikuti-kami.svg" class="w-full xl:w-1/2" alt="" />  
                </div>
              </div>
            </main>
          </div>
            
        </section>
    </footer>
</template>
<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
